<template>
  <div class="page-section">
    <div class="info-title" style="padding-top: 63px; margin-bottom: 0px;">
      <img src="../../../../assets/syndesi/smartsaver-logo.svg" />
    </div>
    <h1 class="info-title">Keep your accountant in the loop</h1>
    <div class="section-subtitle">
      Ensure your accountant has everything they need ahead of time to make your next meeting more productive.
      <br />
      <br />
      <b>Keep this tab or refer to it in the email sent to</b> you to share a clear, concise snapshot of your financials with your accountant.
    </div>
  </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
@import '../../../../scss/riseup-vars.scss';

.page-section {
  background-color: #fcf7ed;
  color: #202125;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding-bottom: 35px;
}

.info-title {
  font-size: 30px;
  color: #202125;
  padding-top: 40px;
  padding-right: 25px;
  margin-bottom: 20px;
  text-align: left;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  font-weight: 700 !important;
  line-height: 1;
}

.section-subtitle {
  font-size: 17px;
  margin-top: 25px;
  margin-bottom: 40px;
  color: #202125;
  text-align: left;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.5;
}
</style>
